module.exports = __webpack_public_path__ + "static/img/en_US3.ede9888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en_US3.png
// module id = XS6g
// module chunks = 1